module.exports = __webpack_public_path__ + "static/media/Barmag 5b3.57ff896f.jpg";